/* The leader dots fill left to right as the cursor closes on the Add to cart
   button, so the row reads as a run-up to the action rather than as static
   decoration.

   The dots themselves are a repeating gradient painted across the whole
   strip; what moves is a mask, so nothing is added to or removed from the
   DOM on pointer move and the dot pitch never shifts. Progress is measured
   between two fixed points -- the left edge of the strip and the left edge
   of the button -- so it is 0 where the dots start and 1 where the button
   begins, whatever the row's width.

   ONLY WHOLE DOTS. A mask set to a raw percentage cuts through whichever dot
   it lands on and leaves a sliver. The gradient's tile is PITCH px wide with
   the dot centred in it, so the dot occupies 6..14 of every 20px cell and the
   only cut that is clean is a cell boundary: a mask ending at PITCH * n shows
   n whole dots and no part of dot n+1. So the fill is quantised to a multiple
   of PITCH and written in px, never as a percentage -- including the "full"
   case, because the strip's own width is not a round number of cells either
   and 100% would clip the last dot against the element edge.

   WITHOUT A CURSOR there is nothing to track, so touch devices get the full
   run rather than an empty strip. The dots are hidden under 760px anyway;
   this covers the tablet case between that and a mouse. */
(function () {
  'use strict';

  var PITCH = 20; /* must match background-size on .rp-dots */

  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }

  /* Largest whole number of dots that fits in `px`, expressed in px. */
  function snap(px) {
    var n = Math.floor(px / PITCH);
    return (n > 0 ? n * PITCH : 0) + 'px';
  }

  function wire(bar) {
    var dots = bar.querySelector('.rp-dots');
    var atc = bar.querySelector('.rp-atc');
    if (!dots || !atc || dots.dataset.rpWired) return;
    dots.dataset.rpWired = '1';

    function set(px) { dots.style.setProperty('--rp-dot-fill', snap(px)); }
    function full() { set(dots.getBoundingClientRect().width); }

    var hover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    if (!hover) {
      full();
      window.addEventListener('resize', full);
      return;
    }

    set(0);

    bar.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch') { full(); return; }
      var d = dots.getBoundingClientRect();
      var a = atc.getBoundingClientRect();
      if (a.left <= d.left) { full(); return; }
      /* Progress runs from the strip's left edge to the button's left edge,
         then is spent across the strip's own width so the run is complete
         exactly as the cursor reaches the button. */
      set(clamp((e.clientX - d.left) / (a.left - d.left)) * d.width);
    });

    /* On the button, the run-up is over. */
    atc.addEventListener('pointerenter', full);
    bar.addEventListener('pointerleave', function () { set(0); });

    /* Keyboard users never move a pointer, so reaching the button by tab
       should fill the run too -- otherwise the strip reads as disabled. */
    atc.addEventListener('focus', full);
    atc.addEventListener('blur', function () { set(0); });
  }

  function run() {
    var bars = document.querySelectorAll('.rp-feature-bar');
    for (var i = 0; i < bars.length; i++) wire(bars[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
